<!-- 
Tooltip doesn't belong to the developer.
This is a modified version of this Source code - https://github.com/Abreu00/svelte-tooltip 
-->

<script>
  export let tip = "";
  export let top = false;
  export let right = false;
  export let bottom = false;
  export let left = false;
  export let active = false;
  export let show = true;
  export let color = "#757575";
  let style = `background-color: ${color};`;
</script>

<style>
  .tooltip-wrapper {
    position: relative;
    /* display: inline-block; */
    display: block;
    color: white
  }
  .tooltip {
    position: absolute;
    font-family: inherit;
    font-size: 0.8rem;
    display: inline-block;
    white-space: normal;
    color: inherit;
    opacity: 0;
    visibility: hidden;
    transition: opacity 150ms, visibility 150ms;
  }
  .default-tip {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 6px;
    color: inherit;
  }
  .tooltip.top {
    left: 50%;
    transform: translate(-50%, -100%);
    margin-top: -8px;
  }
  .tooltip.bottom {
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 100%);
    margin-bottom: -8px;
  }
  .tooltip.left {
    left: 0;
    transform: translateX(-100%);
    margin-left: -8px;
  }
  .tooltip.right {
    right: 0;
    transform: translateX(100%);
    margin-right: -8px;
  }
  .tooltip.active {
    opacity: 1;
    visibility: initial;
  }
  .tooltip.show {
      visibility: hidden;
  }
  .tooltip-slot:hover + .tooltip {
    opacity: 1;
    visibility: initial;
  }
</style>


<div class="tooltip-wrapper">
  <span class="tooltip-slot">
    <slot />
  </span>
  {#if show}
    <div
        class="tooltip"
        class:active
        class:show
        class:left
        class:right
        class:bottom
        class:top>
        {#if tip}
        <div class="default-tip" {style}>{tip}</div>
        {:else}
        <slot name="custom-tip" />
        {/if}

    </div>
  {/if}
</div>
